import React from "react";

export default function ContentCover({ children }) {
  return <div className="content-cover">{children}</div>;
}
